interface ApplicationTokenResponse {
  access_token?: string;
}

export interface GetTenantApiTokenOptions {
  hostname?: string;
  obtenerAplicacion?: (hostname: string) => Promise<ApplicationTokenResponse>;
}

interface AplicacionesApiModule {
  default: {
    obtenerAplicacion: (hostname: string) => Promise<ApplicationTokenResponse>;
  };
}

function getAplicacionesApi() {
  // Lazy require avoids loading legacy Axios/browser helpers in unit tests
  // that inject their own token source.

  return (require('legacyfrontend/api/aplicaciones') as AplicacionesApiModule).default;
}

/**
 * Tenant API token boundary.
 *
 * Single source of the per-hostname application token used by every
 * Package Suppliers backed call (hotels, packages, flights).
 * Never logs or persists the token value.
 */
export async function getTenantApiToken(
  options?: GetTenantApiTokenOptions,
): Promise<string | null> {
  const hostname =
    options?.hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '');

  if (!hostname) return null;

  try {
    const obtenerAplicacion = options?.obtenerAplicacion ?? getAplicacionesApi().obtenerAplicacion;
    const response = await obtenerAplicacion(hostname);
    return response.access_token || null;
  } catch {
    return null;
  }
}
